module.exports = __webpack_public_path__ + "assets/img/IMG005.2942f434.png";